import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GtmService } from '../../../../../shared/cardholders-core/services/gtm.service';
import { ModalService } from '../../../../../shared/modules/bs-modal/services/modal.service';
import { IStandingOrderData } from '../../../interfaces/ICheckForCardResponse.interface';

@Component({
    selector: 'app-transfer-popup',
    templateUrl: './transfer-popup.component.html',
    styleUrls: ['./transfer-popup.component.scss']
})
export class TransferPopupComponent implements OnInit {
    checked = false;
    indeterminate = false;
    labelPosition = 'after';
    disabled = false;
    allChecked = false;
    showErrorMsg = false;
    @Input() transactions: IStandingOrderData[] = [];

    constructor(private modalSvc: ModalService, public bsModalRef: BsModalRef, private gtmService: GtmService) {}

    ngOnInit(): void {
        this.gtmService.pushDirectDebit('choose standing order', 'load');
    }

    close(): void {
        this.modalSvc.closeModal();
    }
    getSymbol(curency: number): string {
        switch (curency) {
            case 0:
            case 376:
                return '₪';
            case 840:
                return '$';
            case 978:
                return '€';
            default:
                return '₪';
        }
    }
    selectTransaction(index: number): void {
        this.transactions[index].isChecked = !this.transactions[index].isChecked;
        this.allChecked = !this.transactions.some((x) => x.isChecked === false);
        this.showErrorMsg = false;
    }

    selectAllTransactions(): void {
        this.transactions.forEach((x) => (x.isChecked = !this.allChecked));
        this.allChecked = !this.allChecked;
        this.showErrorMsg = false;
    }

    transferDirectDebits(): void {
        if (!this.transactions.some((x) => x.isChecked === true)) {
            this.showErrorMsg = true;
            return;
        }
        this.gtmService.pushDirectDebitWorkFlow('choose standing order', 'continue', '2');
        this.modalSvc.closeModalAndAlertSubscribers(this.transactions.filter(x => x.isChecked === true));
    }
}
